import React from 'react'
import RatedProgramView from "../../views/ver_24.10/ProgramRating/DQRating/DQRatedProgram.view";
import {useHistory} from "react-router-dom";

const RatedProgramMain = () => {
    const history = useHistory();
    const data = {

    };

    // Actions handling business logic
    const actions = {
        ViewReportAction : () => {
            history.push("/rating/content_report");
        },
    };

    // Configuration options for visual appearance
    const options = {
    };
    return (
        <>
            <RatedProgramView
                data={data}
                actions={actions}
                options={options}
            />
        </>
    );
}

export default RatedProgramMain;